// dayjs拡張 HHのかわりにh34を書くと34時までの表記になる
export default (option, dayjsClass) => {
  const oldFormat = dayjsClass.prototype.format

  dayjsClass.prototype.format = function (formatStr) {
    if (!this.isValid()) {
      return oldFormat.bind(this)(formatStr)
    }
    const str = formatStr || 'YYYY-MM-DDThh:mm:ssZ'
    const result = str.replace(/h.*?(?=:)/, (match) => {
      switch (match) {
        case 'h34':
          return this.$H + 24
        default:
          return match
      }
    })
    return oldFormat.bind(this)(result)
  }
}
